export function checkIfNumber(event) {
  return (
    (event.keyCode >= 48 && event.keyCode <= 57) ||
    (event.keyCode >= 96 && event.keyCode <= 105) ||
    event.keyCode === 8 ||
    event.keyCode === 9
  );
}

export function checkIfNumberOrDot(event) {
  return (
    (event.keyCode >= 48 && event.keyCode <= 57) ||
    (event.keyCode >= 96 && event.keyCode <= 105) ||
    event.keyCode === 8 ||
    event.keyCode === 190 ||
    event.keyCode === 110 ||
    event.keyCode === 9
  );
}

export function checkIfNumberOrSlash(event) {
  return (
    (event.keyCode >= 48 && event.keyCode <= 57) ||
    (event.keyCode >= 96 && event.keyCode <= 105) ||
    event.keyCode === 8 ||
    event.keyCode === 191 ||
    event.keyCode === 37 ||
    event.keyCode === 39 ||
    event.keyCode === 9
  );
}

export function isValidEmail(email) {
  let regexOfEmail =
    // eslint-disable-next-line
    /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/; //NOSONAR
  return regexOfEmail.test(email);
}

/**
 * Validate name fields
 * @param {string} name
 */
export function isValidName(name) {
  let regexForAlphabets = /^[a-zA-Z ]*$/;
  return regexForAlphabets.test(name);
}
